import React from 'react';
import { DUCT_TYPES, DUCT_SHAPES, FITTING_TYPES } from '../../constants/hvacOptions';

/**
 * SVG Icons for HVAC Tools
 */
const SupplyDuctIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="8" width="20" height="8" rx="1" fill={DUCT_TYPES.supply.color} fillOpacity="0.3" />
    <rect x="2" y="8" width="20" height="8" rx="1" stroke={DUCT_TYPES.supply.color} />
    <path d="M6 12h4M14 12h4" stroke={DUCT_TYPES.supply.color} />
    <path d="M10 10l2 2-2 2" stroke={DUCT_TYPES.supply.color} />
  </svg>
);

const ReturnDuctIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="8" width="20" height="8" rx="1" fill={DUCT_TYPES.return.color} fillOpacity="0.3" />
    <rect x="2" y="8" width="20" height="8" rx="1" stroke={DUCT_TYPES.return.color} />
    <path d="M6 12h4M14 12h4" stroke={DUCT_TYPES.return.color} />
    <path d="M14 10l-2 2 2 2" stroke={DUCT_TYPES.return.color} />
  </svg>
);

const FlexDuctIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12c0-3 2-4 4-4s4 2 6 2 4-2 6-2" stroke={color} />
    <path d="M4 12c0 3 2 4 4 4s4-2 6-2 4 2 6 2" stroke={color} />
    <ellipse cx="4" cy="12" rx="2" ry="4" fill={color} fillOpacity="0.2" stroke={color} />
    <ellipse cx="20" cy="10" rx="2" ry="4" fill={color} fillOpacity="0.2" stroke={color} />
  </svg>
);

const ElbowIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4v10a6 6 0 006 6h10" fill={color} fillOpacity="0.1" />
    <path d="M4 4v10a6 6 0 006 6h10" />
  </svg>
);

const TeeIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8h16M12 8v12" />
    <rect x="3" y="6" width="18" height="4" rx="1" fill={color} fillOpacity="0.1" />
    <rect x="10" y="8" width="4" height="12" rx="1" fill={color} fillOpacity="0.1" />
  </svg>
);

const RegisterIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="8" rx="1" fill={color} fillOpacity="0.2" />
    <rect x="3" y="8" width="18" height="8" rx="1" />
    <line x1="6" y1="8" x2="6" y2="16" />
    <line x1="9" y1="8" x2="9" y2="16" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="15" y1="8" x2="15" y2="16" />
    <line x1="18" y1="8" x2="18" y2="16" />
  </svg>
);

const SupplyVentIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="6" width="16" height="12" rx="1" fill="#e65100" fillOpacity="0.3" />
    <rect x="4" y="6" width="16" height="12" rx="1" stroke="#e65100" />
    <line x1="6" y1="9" x2="18" y2="9" stroke="#e65100" />
    <line x1="6" y1="12" x2="18" y2="12" stroke="#e65100" />
    <line x1="6" y1="15" x2="18" y2="15" stroke="#e65100" />
    <path d="M12 18l-3 4M12 18l3 4" stroke="#e65100" strokeOpacity="0.6" />
  </svg>
);

const ReturnVentIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="4" width="16" height="16" rx="1" fill="#1565c0" fillOpacity="0.3" />
    <rect x="4" y="4" width="16" height="16" rx="1" stroke="#1565c0" />
    <line x1="9" y1="4" x2="9" y2="20" stroke="#1565c0" />
    <line x1="15" y1="4" x2="15" y2="20" stroke="#1565c0" />
    <line x1="4" y1="9" x2="20" y2="9" stroke="#1565c0" />
    <line x1="4" y1="15" x2="20" y2="15" stroke="#1565c0" />
  </svg>
);

const EquipmentIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" fill={color} fillOpacity="0.2" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.5" fill={color} />
    <path d="M12 7v-1M12 18v-1M7 12h-1M18 12h-1" />
  </svg>
);

const SelectIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4l7 16 2-6 6-2L4 4z" fill={color} fillOpacity="0.15" />
    <path d="M4 4l7 16 2-6 6-2L4 4z" />
    <path d="M13 13l6 6" />
  </svg>
);

const RoomDataIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" fill={color} fillOpacity="0.1" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <text x="14" y="16" fontSize="7" fill={color} fontWeight="bold">J</text>
  </svg>
);

const LayersIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2" fill={color} fillOpacity="0.1" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);

const SummaryIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" fill={color} fillOpacity="0.1" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="8" y1="8" x2="16" y2="8" />
    <line x1="8" y1="12" x2="16" y2="12" />
    <line x1="8" y1="16" x2="12" y2="16" />
  </svg>
);

const ExportIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const StampIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="14" width="18" height="6" rx="1" fill={color} fillOpacity="0.2" />
    <rect x="3" y="14" width="18" height="6" rx="1" />
    <path d="M7 14V10a5 5 0 0 1 10 0v4" />
    <rect x="6" y="6" width="12" height="4" rx="1" fill={color} fillOpacity="0.3" />
  </svg>
);

const CFMIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="8" width="16" height="8" rx="2" fill={color} fillOpacity="0.2" />
    <rect x="2" y="8" width="16" height="8" rx="2" />
    <text x="10" y="14" fontSize="6" fill={color} textAnchor="middle" fontWeight="bold">CFM</text>
    <path d="M18 12h4" />
    <path d="M20 10l2 2-2 2" />
  </svg>
);

const LabelIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 8h14M5 12h10M5 16h6" />
    <rect x="16" y="10" width="6" height="8" rx="1" fill={color} fillOpacity="0.2" />
    <rect x="16" y="10" width="6" height="8" rx="1" />
    <text x="19" y="16" fontSize="5" fill={color} textAnchor="middle" fontWeight="bold">8"</text>
  </svg>
);

/**
 * HVACToolbar - Toolbar for HVAC drawing tools
 */
const LoadCalcIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" fill={color} fillOpacity="0.1" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M7 8h10M7 12h6M7 16h8" />
    <circle cx="17" cy="14" r="3" fill={color} fillOpacity="0.3" stroke={color} />
    <text x="17" y="16" fontSize="5" fill={color} textAnchor="middle" fontWeight="bold">J</text>
  </svg>
);

const DuctulatorIcon = ({ color = '#6080a0', size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none"
    stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2.5" fill={color} fillOpacity="0.3" />
    <line x1="12" y1="2" x2="12" y2="5" />
    <line x1="12" y1="19" x2="12" y2="22" />
    <line x1="2" y1="12" x2="5" y2="12" />
    <line x1="19" y1="12" x2="22" y2="12" />
  </svg>
);

const HVACToolbar = ({
  activeTool,
  onToolChange,
  ductType,
  onDuctTypeChange,
  ductShape,
  onDuctShapeChange,
  ductSize,
  onDuctSizeChange,
  onShowVentPlacer,
  onShowEquipmentLibrary,
  onShowRoomData,
  onShowLoadCalc,
  onShowDuctulator,
  onShowLayers,
  onShowSummary,
  onShowExport,
  onShowStamps,
  onShowLabels,
  showLabelsOnDucts,
  onToggleDuctLabels,
  showLayers = false,
  showSummary = false,
  showLoadCalc = false,
  showDuctulator = false,
  isMobile = false,
  onClose,
}) => {
  const buttonStyle = (active) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: isMobile ? 'column' : 'row',
    gap: isMobile ? '2px' : '4px',
    padding: isMobile ? '6px 8px' : '8px 12px',
    minWidth: isMobile ? '44px' : 'auto',
    background: active ? 'rgba(0,200,255,0.2)' : 'rgba(255,255,255,0.05)',
    border: `1px solid ${active ? 'rgba(0,200,255,0.4)' : 'rgba(255,255,255,0.1)'}`,
    borderRadius: '6px',
    color: active ? '#00c8ff' : '#8090a0',
    fontSize: isMobile ? '9px' : '12px',
    cursor: 'pointer',
    fontWeight: active ? '600' : '400',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s ease',
  });

  const sectionStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '0 8px',
    borderRight: '1px solid rgba(255,255,255,0.1)',
  };

  const labelStyle = {
    color: '#6080a0',
    fontSize: '10px',
    marginRight: '4px',
  };

  const selectStyle = {
    padding: '6px 8px',
    background: '#1a1f24',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '11px',
    cursor: 'pointer',
    outline: 'none',
  };

  const currentDuctType = DUCT_TYPES[ductType] || DUCT_TYPES.supply;
  const sizes = currentDuctType.sizes;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        background: 'rgba(0,0,0,0.3)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        flexWrap: 'wrap',
      }}
    >
      {/* Exit HVAC Mode - mobile only */}
      {isMobile && onClose && (
        <div style={sectionStyle}>
          <button
            onClick={onClose}
            style={{
              ...buttonStyle(false),
              background: 'rgba(230, 81, 0, 0.3)',
              borderColor: '#e65100',
              color: '#ff9800',
            }}
            title="Exit HVAC Mode"
          >
            <svg viewBox="0 0 24 24" width={16} height={16} fill="none" stroke="#ff9800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
            <span>Exit</span>
          </button>
        </div>
      )}

      {/* Select Tool */}
      <div style={sectionStyle}>
        <button
          onClick={() => onToolChange('select')}
          style={buttonStyle(activeTool === 'select')}
          title="Select"
        >
          <SelectIcon color={activeTool === 'select' ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Select</span>
        </button>
      </div>

      {/* Duct Drawing Tools */}
      <div style={sectionStyle}>
        <button
          onClick={() => {
            onDuctTypeChange('supply');
            onToolChange('duct');
          }}
          style={buttonStyle(activeTool === 'duct' && ductType === 'supply')}
          title="Supply Duct"
        >
          <SupplyDuctIcon size={isMobile ? 16 : 18} />
          <span>Supply</span>
        </button>
        <button
          onClick={() => {
            onDuctTypeChange('return');
            onToolChange('duct');
          }}
          style={buttonStyle(activeTool === 'duct' && ductType === 'return')}
          title="Return Duct"
        >
          <ReturnDuctIcon size={isMobile ? 16 : 18} />
          <span>Return</span>
        </button>
      </div>

      {/* Duct Shape */}
      {activeTool === 'duct' && (
        <div style={sectionStyle}>
          <button
            onClick={() => onDuctShapeChange('trunk')}
            style={buttonStyle(ductShape === 'trunk')}
            title="Trunk (Rectangular)"
          >
            <svg viewBox="0 0 24 24" width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} fill="none" stroke={ductShape === 'trunk' ? '#00c8ff' : '#6080a0'} strokeWidth="2">
              <rect x="4" y="8" width="16" height="8" rx="1" />
            </svg>
            <span>Trunk</span>
          </button>
          <button
            onClick={() => onDuctShapeChange('flex')}
            style={buttonStyle(ductShape === 'flex')}
            title="Flex (Round)"
          >
            <FlexDuctIcon color={ductShape === 'flex' ? '#00c8ff' : '#6080a0'} size={isMobile ? 14 : 16} />
            <span>Flex</span>
          </button>
        </div>
      )}

      {/* Duct Size */}
      {activeTool === 'duct' && (
        <div style={{ ...sectionStyle, borderRight: 'none' }}>
          <span style={labelStyle}>Size:</span>
          <select
            value={ductSize}
            onChange={(e) => onDuctSizeChange(Number(e.target.value))}
            style={selectStyle}
          >
            {sizes.map((size) => (
              <option key={size.value} value={size.value}>
                {size.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Vents */}
      <div style={sectionStyle}>
        <button
          onClick={() => {
            onToolChange('supply-vent');
            onShowVentPlacer?.('supply-floor');
          }}
          style={buttonStyle(activeTool === 'supply-vent')}
          title="Supply Register"
        >
          <SupplyVentIcon size={isMobile ? 16 : 18} />
          <span>Vent</span>
        </button>
        <button
          onClick={() => {
            onToolChange('return-vent');
            onShowVentPlacer?.('return-standard');
          }}
          style={buttonStyle(activeTool === 'return-vent')}
          title="Return Grille"
        >
          <ReturnVentIcon size={isMobile ? 16 : 18} />
          <span>Grille</span>
        </button>
      </div>

      {/* Equipment */}
      <div style={{ ...sectionStyle, borderRight: 'none' }}>
        <button
          onClick={() => {
            onToolChange('equipment');
            onShowEquipmentLibrary?.();
          }}
          style={buttonStyle(activeTool === 'equipment')}
          title="HVAC Equipment"
        >
          <EquipmentIcon color={activeTool === 'equipment' ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Equip</span>
        </button>
      </div>

      {/* Fittings */}
      <div style={sectionStyle}>
        <button
          onClick={() => onToolChange('elbow')}
          style={buttonStyle(activeTool === 'elbow')}
          title="Elbow Fitting"
        >
          <ElbowIcon color={activeTool === 'elbow' ? '#00c8ff' : '#6080a0'} size={isMobile ? 14 : 16} />
          <span>Elbow</span>
        </button>
        <button
          onClick={() => onToolChange('tee')}
          style={buttonStyle(activeTool === 'tee')}
          title="Tee Fitting"
        >
          <TeeIcon color={activeTool === 'tee' ? '#00c8ff' : '#6080a0'} size={isMobile ? 14 : 16} />
          <span>Tee</span>
        </button>
      </div>

      {/* Room Data (Manual J) */}
      <div style={sectionStyle}>
        <button
          onClick={() => {
            onToolChange('room-data');
            onShowRoomData?.();
          }}
          style={buttonStyle(activeTool === 'room-data')}
          title="Room Data for Manual J"
        >
          <RoomDataIcon color={activeTool === 'room-data' ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Room</span>
        </button>
        <button
          onClick={() => onShowLoadCalc?.()}
          style={{
            ...buttonStyle(showLoadCalc),
            background: showLoadCalc ? 'rgba(76,175,80,0.2)' : 'rgba(255,255,255,0.05)',
            borderColor: showLoadCalc ? 'rgba(76,175,80,0.4)' : 'rgba(255,255,255,0.1)',
          }}
          title="Load Calculations (Manual J)"
        >
          <LoadCalcIcon color={showLoadCalc ? '#4caf50' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Load</span>
        </button>
        <button
          onClick={() => onShowDuctulator?.()}
          style={{
            ...buttonStyle(showDuctulator),
            background: showDuctulator ? 'rgba(0,200,255,0.2)' : 'rgba(255,255,255,0.05)',
            borderColor: showDuctulator ? 'rgba(0,200,255,0.4)' : 'rgba(255,255,255,0.1)',
          }}
          title="Duct Size Calculator"
        >
          <DuctulatorIcon color={showDuctulator ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Duct Calc</span>
        </button>
      </div>

      {/* Stamps and Labels */}
      <div style={sectionStyle}>
        <button
          onClick={() => {
            onToolChange('stamp');
            onShowStamps?.();
          }}
          style={buttonStyle(activeTool === 'stamp')}
          title="Place Markup Stamps"
        >
          <StampIcon color={activeTool === 'stamp' ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Stamp</span>
        </button>
        <button
          onClick={() => {
            onToolChange('cfm-label');
            onShowLabels?.('CFM');
          }}
          style={buttonStyle(activeTool === 'cfm-label')}
          title="Add CFM Labels"
        >
          <CFMIcon color={activeTool === 'cfm-label' ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>CFM</span>
        </button>
        <button
          onClick={() => {
            onToolChange('duct-label');
            onShowLabels?.('DUCT_SIZE');
          }}
          style={buttonStyle(activeTool === 'duct-label')}
          title="Add Duct Size Labels"
        >
          <LabelIcon color={activeTool === 'duct-label' ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Sizes</span>
        </button>
        {/* Toggle auto duct labels */}
        <button
          onClick={() => onToggleDuctLabels?.()}
          style={{
            ...buttonStyle(showLabelsOnDucts),
            background: showLabelsOnDucts ? 'rgba(230,81,0,0.2)' : 'rgba(255,255,255,0.05)',
            borderColor: showLabelsOnDucts ? 'rgba(230,81,0,0.4)' : 'rgba(255,255,255,0.1)',
          }}
          title="Toggle Auto Duct Size Labels"
        >
          <span style={{
            fontSize: '10px',
            fontWeight: '600',
            color: showLabelsOnDucts ? '#e65100' : '#6080a0',
          }}>
            Auto
          </span>
        </button>
      </div>

      {/* Layers, Summary, and Export */}
      <div style={{ ...sectionStyle, borderRight: 'none', marginLeft: 'auto' }}>
        <button
          onClick={() => onShowLayers?.()}
          style={buttonStyle(showLayers)}
          title="HVAC Layers"
        >
          <LayersIcon color={showLayers ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Layers</span>
        </button>
        <button
          onClick={() => onShowSummary?.()}
          style={buttonStyle(showSummary)}
          title="HVAC Summary"
        >
          <SummaryIcon color={showSummary ? '#00c8ff' : '#6080a0'} size={isMobile ? 16 : 18} />
          <span>Info</span>
        </button>
        <button
          onClick={() => onShowExport?.()}
          style={{
            ...buttonStyle(false),
            background: 'rgba(76, 175, 80, 0.15)',
            borderColor: 'rgba(76, 175, 80, 0.3)',
            color: '#4caf50',
          }}
          title="Export HVAC Data"
        >
          <ExportIcon color="#4caf50" size={isMobile ? 16 : 18} />
          <span>Export</span>
        </button>
      </div>
    </div>
  );
};

export default HVACToolbar;
